<template>
  <div class="chat-container">
    <div class="close" @click="close"></div>
    <chatResponse></chatResponse>


    <div class="left-bottom">
      <div class="title-box">
        <div class="title-logo"></div>
        <div class="title-txt">搜索流程</div>
      </div>

      <div class="step-box">
        <div class="step-img">
          <div class="step-item" v-for="(item, index) in stepAssetList" :key="index">
            <div @click="stepClickImg(index)">
              <div v-if="allImg !== 'all'">
                <img v-if="describeIndex !== index" style="cursor: pointer;" :src="item.src" alt="">
                <img v-if="describeIndex === index" style="cursor: pointer;" :src="item.lightSrc" alt="">
              </div>

              <img v-if="allImg === 'all'" style="cursor: pointer;" :src="item.lightSrc" alt="">
            </div>
            <div class="step-name">{{item.name}}</div>
            <div v-if="describeIndex === index" class="step-describe">
              <div class="describe-title">12啊实打实的s asdaasdasdssa d3</div>
              asdaasdasdaasdasdasd
              asdasdasdasdasdasdasdasdasdasdasdasdasdasdasdsdasdasdaasdasdasdasdasd
              asdasdasdasdasdasdasdasdasdasdasdasdasdsdasdasdaasdasdasdasdasdasdasdasdasdas
              dasdasdasdasdasdasdasdasdsdsdaasdasdasdasdasdasdasdasdasdasdasdasdasdasdasdasdasdasdsd</div>
            <div v-if="index < stepAssetList.length - 1" class="step-border"></div>
          </div>
        </div>
      </div>

    </div>


    <div class="right-box">
      <div class="title-box">
        <div class="title-logo title-left-bottom"></div>
        <div class="title-txt">搜索问答</div>
      </div>

      <div class="chat-box">
        <div v-for="(message, index) in chatList" :key="index" class="chat-message" :class="message.type">
          {{ message.content }}

<!--      这是回答列表-->
          <div v-if="message.type === 'response' && message.mode === 'table'" class="chat-table-response">
            <div class="chat-table-item-title">
              <td>国家</td>
              <td>数量</td>
            </div>
            <div v-for="item in message.dataList" class="chat-table-item-value">
              <td>{{item.name}}</td>
              <td>{{item.num}}</td>
            </div>
          </div>

<!--      这是回答柱状图-->
          <div v-if="message.type === 'response' && message.mode === 'bar'" class="chat-bar-response">
            <div class="chat-bar-item" v-for="item in message.dataList">
              <div class="chat-bar-num">{{item.num}}</div>
              <div class="chat-bar-img1">
                <img src="@/assets/bar/you.png" alt="">
              </div>
              <div class="chat-bar-img2">
                <img src="@/assets/bar/top.png" alt="">
              </div>
              <div class="chat-bar-img3">
                <img src="@/assets/bar/down.png" alt="">
              </div>
              <div class="chat-bar-img4">
                <img src="@/assets/bar/buttom.png" alt="">
              </div>
              <div class="chat-bar-date">{{item.date}}</div>
            </div>
          </div>

        </div>
      </div>

      <div class="search-chat">
        <div>
          <el-input placeholder="漏洞搜索" v-model="newChatValue" class="input-with-select">
            <el-button @click="search" slot="append" icon="el-icon-search"></el-button>
            <el-button @click="refresh" slot="append" icon="el-icon-refresh"></el-button>
          </el-input>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import _ from "lodash";
export default {
  name: "chat",
  props: ["chatValue"],
  data() {
    return {
      newChatValue: "",
      oldChatValue: "",
      describeIndex: "",
      allImg: "all",
      chatList: [],

      stepAssetList: [
        {src: require("@/assets/step/log_dark_1.png"), lightSrc: require("@/assets/step/log_light_1.png"), name: "步骤1"},
        {src: require("@/assets/step/log_dark_2.png"), lightSrc: require("@/assets/step/log_light_2.png"), name: "步骤2"},
        {src: require("@/assets/step/log_dark_3.png"), lightSrc: require("@/assets/step/log_light_3.png"), name: "步骤3"},
        {src: require("@/assets/step/log_dark_4.png"), lightSrc: require("@/assets/step/log_light_4.png"), name: "步骤4"}
      ]
    };
  },
  created() {
    this.newChatValue = _.cloneDeep(this.chatValue);
  },
  // TODO describeIndex是点击拿个步骤展示哪个步骤的描述；
  // TODO 步骤完成需要将 allImg 赋值为 all；
  methods: {
    stepClickImg(index) {
      if (this.allImg === "all") {
        this.describeIndex = index;
        const stepItems = document.getElementsByClassName("step-item");

        for (let i = 0; i < stepItems.length; i++) {
          if (i === index) {
            stepItems[i].style.width = "300px"; // 当前点击的宽度变宽
            stepItems[i].style.marginLeft = "-100px"; // 当前点击的宽度变宽
          } else {
            stepItems[i].style.width = "50px"; // 其他宽度变窄
            stepItems[i].style.marginLeft = "0px";
          }
        }

        const stepItemsBorder = document.getElementsByClassName("step-border");

        for (let i = 0; i < stepItemsBorder.length; i++) {
          if (i === index) {
            stepItemsBorder[i].style.marginLeft = "220px"; // 当前点击的宽度变宽
            stepItemsBorder[i].style.width = "150px";
          } else {
            stepItemsBorder[i].style.marginLeft = "65px"; // 其他宽度变窄
            stepItemsBorder[i].style.width = "95px";
          }
        }
      } else {
        this.$message({
          type: "warning",
          message: "请等待步骤条完成！点击步骤查看！"
        });
      }
    },
    close() {
      this.$emit("close");
    },
    searchMethods(val) {
      if (val.trim()) {
        // 添加用户输入到右侧
        this.chatList.push({ content: val, type: "user" });
        // 模拟回答并添加到左侧
        setTimeout(() => {
          this.chatList.push(
            {
              content: "这是一个回答的内容",
              type: "response",
              mode: "table", //TODO mode是table时返回的是回答和列表
              dataList: [
                {name: "11", num: "123123"},
                {name: "11", num: "123123"},
                {name: "11", num: "123123"}
              ]
            },
            {
              content: "这是一个回答的内容",
              type: "response",
              mode: "bar", //TODO mode是bar时返回的是回答和柱状图
              dataList: [
                {date: "5-13", num: "85"},
                {date: "5-14", num: "75"},
                {date: "5-15", num: "58"},
                {date: "5-15", num: "58"},
                {date: "5-15", num: "58"},
                {date: "5-16", num: "98"}
              ]
            }
          );
        }, 1000);

        this.oldChatValue = _.cloneDeep(val);
        // 清空输入框
        this.newChatValue = "";
      }
    },
    search() {
      this.searchMethods(this.newChatValue);
    },
    refresh() {
      this.searchMethods(this.oldChatValue);
    }
  }
};
</script>

<style scoped lang="less">
.chat-container{
  display: block;
  position: relative;
  left: 77px;
  width: 1764px;
  height: 840px;
  //background-color: #cdf5c5;
}
.close {
  position: absolute;
  width: 24px;
  height: 24px;
  top: -30px;
  cursor: pointer;
  z-index: 999;
  background-color: #2A38B4;
}
.left-bottom {
  width: 993px;
  height: 278px;
  position: absolute;
  top: 620px;
  background: linear-gradient(to right, rgba(73, 74, 98, 0.3), rgba(108, 111, 157, 0.2));
  border-radius: 5px;
  z-index: 10;
}
.right-box {
  text-align: left;
  width: 750px;
  height: 878px;
  position: absolute;
  top: 20px;
  left: 1020px;
  background: linear-gradient(to right, rgba(73, 74, 98, 0.3), rgba(108, 111, 157, 0.2));
  border-radius: 5px;
  z-index: 10;
}
.title-box {
  .title-logo {
    background-image: url("../assets/img/ask_logo.png");
    background-repeat: no-repeat;
    background-size: 100%;
    height: 53px;
    width: 59px;
    position: absolute;
    left: 20px;
    top: 15px;
  }
  .title-left-bottom {
    background-image: url("../assets/img/chat.png");
  }
  .title-txt {
    background-image: url("../assets/img/ask_bg.png");
    background-repeat: no-repeat;
    background-size: 100%;
    color: rgba(241, 237, 255, 1);
    font-family: 'YouSheBiaoTiHei';
    font-size: 24px;
    height: 54px;
    width: 260px;
    line-height: 54px;
    position: absolute;
    left: 79px;
    top: 15px;
    text-shadow: 0 2px 20px rgba(42, 56, 180, 1);
    text-align: left;
    padding-left: 20px;
  }
}
.search-chat {
  position: absolute;
  bottom: 10px;
  left: 40px;
  width: 670px;
  height: 54px;
}
/deep/.el-input__inner {
  background-color: #273264;
  border: 1px solid #c1c2fe;
  border-right: none;
  color: #fff;
}
/deep/.el-input-group__append {
  background-color: #273264;
  border: 1px solid #c1c2fe;
  border-left: none;
  color: #fff;
}


.chat-box {
  position: absolute;
  top: 90px;
  left: 20px;
  width: 690px;
  height: 690px;
  border-radius: 8px;
  padding: 10px;
  overflow-y: auto; /* 允许纵向滚动 */
  display: flex;
  flex-direction: column;
  gap: 10px; /* 气泡间距 */
  color: #FFFFFF;
}

.chat-message {
  max-width: 70%;
  padding: 10px;
  border-radius: 8px;
  margin-bottom: 10px;
  word-wrap: break-word;
}

.chat-message.user {
  background-color: rgba(119, 121, 133, 0.4); /* 用户消息绿色背景 */
  color: #FFFFFF;
  font-size: 16px;
  border-bottom-right-radius: 0;
  align-self: flex-end;
}

.chat-message.response {
  font-size: 16px;
  background: linear-gradient(to right, rgba(73, 74, 98, 0.4), rgba(108, 111, 157, 0.3));
  color: #FFFFFF;
  border-bottom-left-radius: 0;
  align-self: flex-start;
}

.chat-table-response {
  background-color: #5a6288;
  border-radius: 5px;
  margin-top: 5px;
  .chat-table-item-title {
    td {
      width: 100px;
      text-align: center;
    }
  }
  .chat-table-item-value {
    border-top: 1px solid #6f74a4;
    td {
      width: 100px;
      text-align: center;
    }
  }
}

.chat-bar-response {
  background-color: #5a6288;
  border-radius: 5px;
  margin-top: 5px;
  padding: 5px;
  display: flex;
  .chat-bar-item {
    margin: 0 5px;
    text-align: center;
    .chat-bar-num {
      font-family: 'YouSheBiaoTiHei';
    }
    .chat-bar-img1 {
      margin-top: -20px;
    }
    .chat-bar-img2 {
      margin-top: -20px;
    }
    .chat-bar-img3 {
      margin-top: -15px;
    }
    .chat-bar-img4 {
      margin-top: -20px;
    }
    .chat-bar-date {
      margin-top: -10px;
    }
  }
}

.chat-box::-webkit-scrollbar {
  width: 8px; /* 滚动条宽度 */
  height: 8px; /* 横向滚动条高度 */
}

.chat-box::-webkit-scrollbar-thumb {
  background-color: #757ebe; /* 滚动条的颜色 */
  border-radius: 4px; /* 让滚动条块稍微圆角 */
}

.chat-box::-webkit-scrollbar-track {
  background-color: transparent; /* 滚动条背景透明 */
}

.step-box {
  position: absolute;
  top: 80px;
  left: 20px;
  width: 950px;
  height: 180px;
  //background-color: rgba(1, 240, 255, 0.5);
  .step-img {
    display: flex;
    align-items: center;
    height: 180px;
    justify-content: space-evenly;
    .step-item {
      width: 200px;
    }
  }
  .step-name {
    color: #fff;
    font-size: 14px;
    font-weight: 500;
  }
  .step-describe {
    position: absolute;
    width: 170px;
    height: 100px;
    bottom: 50px;
    margin-left: 200px;
    color: white;
    font-size: 14px;
    font-weight: 500;
    word-break: break-word;
    text-align: left;
    background-color: rgba(159, 158, 242, 0.2);
    padding: 5px;
    overflow-y: auto;
    .describe-title {
      color: rgba(241, 237, 255, 1);
      font-family: 'YouSheBiaoTiHei';
      text-shadow: 0 2px 20px rgba(42, 56, 180, 1);
      font-size: 16px;
    }
  }
  .step-border {
    position: absolute;
    width: 150px;
    height: 2px;
    bottom: 45px;
    margin-left: 140px;
    border-bottom: 2px dashed #9F9EF2;
  }
}

.step-describe::-webkit-scrollbar {
  width: 8px; /* 滚动条宽度 */
  height: 8px; /* 横向滚动条高度 */
}

.step-describe::-webkit-scrollbar-thumb {
  background-color: #757ebe; /* 滚动条的颜色 */
  border-radius: 4px; /* 让滚动条块稍微圆角 */
}

.step-describe::-webkit-scrollbar-track {
  background-color: transparent; /* 滚动条背景透明 */
}
</style>
